export default __webpack_public_path__ + "static/media/6.b0f7aa5b.png";